/**
 * Convert array to object
 *
 * @param {array} array Input array to convert
 * @param {string} key Key to use as identifier
 * @returns {object}
 */
function convertToObject(array, key = 'id') {
  const entries = (Array.isArray(array) ? array : [])
    .map((item, index) => [
      item[key] || index,
      item,
    ]);

  return Object
    .fromEntries(entries);
}

function sort(property) {
  let sortOrder = 1;

  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }

  return function (a, b) {
    const aProp = a[property];
    const bProp = b[property];
    let result;

    if (typeof aProp === 'string' || typeof bProp === 'string') {
      result = (aProp || '').localeCompare(bProp || '');
    } else {
      result = (aProp < bProp) ? -1 : (aProp > bProp) ? 1 : 0;
    }

    return result * sortOrder;
  };
}

function dynamicSort() {
  const props = arguments;
  const numberOfProperties = arguments.length;

  if (numberOfProperties === 1) {
    return sort(props[0]);
  }

  return function (obj1, obj2) {
    let i = 0, result = 0;

    while (result === 0 && i < numberOfProperties) {
      result = sort(props[i])(obj1, obj2);
      i++;
    }
    return result;
  };
}

export {
  convertToObject,
  dynamicSort,
};
